import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import pl from './resources/pl';

export const resources = {
  pl: {
    translation: pl,
  },
};

const userLanguage = typeof window !== 'undefined' ? navigator.language : '';

export type TranslationFnType = (name: string) => string;

// eslint-disable-next-line import/no-named-as-default-member
i18n.use(initReactI18next).init({
  lng: userLanguage,
  resources,
  fallbackLng: 'pl',
});

export default i18n;
